const mui = {
  MuiPaper: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.shadows[0],
      }),
    },
  },
};
export default mui;
